import { TermType } from "@onestore/api/types"
import {
  isResponsePending,
  isResponseSuccessful,
} from "@onestore/onestore-store-common/http"
import { getTermsByType } from "@gatsby-plugin-checkout/lib/terms"
import { createSelector } from "reselect"
import type { CheckoutTermsState } from "~/store/checkout-terms/reducer"
import type { AppState } from "~/store/reducer"

export const getCheckoutTerms = createSelector(
  (state: AppState): CheckoutTermsState => state.checkoutTerms,
  (checkout: CheckoutTermsState): CheckoutTermsState => checkout
)

export const getSummaryTerms = createSelector(
  getCheckoutTerms,
  (checkout) => checkout.terms
)

export const areTermsValid = createSelector(
  getCheckoutTerms,
  (checkout) => checkout.termsValid
)

export const isSummaryPending = createSelector(
  getCheckoutTerms,
  (checkout: AppState["checkoutTerms"]) =>
    isResponsePending(checkout.termsRequest)
)

export const isSummaryLoaded = createSelector(
  getCheckoutTerms,
  (checkout: AppState["checkoutTerms"]) =>
    isResponseSuccessful(checkout.termsRequest)
)

export const areAllTermsChecked = createSelector(getCheckoutTerms, (checkout) =>
  checkout.terms.every((term) => term.checked[checkout.activeTermTabId])
)

export const getActiveTermTabId = createSelector(
  getCheckoutTerms,
  (checkout) => checkout.activeTermTabId
)

export function getTermsForCheckout(state: CheckoutTermsState) {
  return {
    external: getTermsByType(
      TermType.EXTERNAL,
      state.terms,
      state.activeTermTabId
    ),
    internal: getTermsByType(
      TermType.INTERNAL,
      state.terms,
      state.activeTermTabId
    ),
  }
}
